export enum LoginType {
  Unspecified,
  Dashboard,
  Headset,
}
